<mat-toolbar color="primary">
    <span>Contact</span>
</mat-toolbar>
<mat-dialog-content>
    <div fxLayout="row">
        <div fxFlex="grow">
            <div style="max-height:65vh;overflow:scroll;">
                <app-contact [contact]="contact"></app-contact>
            </div>
        </div>
        <div fxFlex="300px">
            <div style="max-height:65vh;overflow:scroll;">
                <mat-accordion class="menu-headers-align" multi>
                    <mat-expansion-panel [expanded]="true">
                        <mat-expansion-panel-header>
                            <mat-panel-title>Problèmes</mat-panel-title>
                        </mat-expansion-panel-header>
                        <app-problem-list [location]="'contact'"></app-problem-list>
                    </mat-expansion-panel>
                    <mat-expansion-panel [expanded]="true">
                        <mat-expansion-panel-header>
                            <mat-panel-title>Traitements</mat-panel-title>
                        </mat-expansion-panel-header>
                        <app-medication-list [location]="'contact'"></app-medication-list>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-stroked-button (click)="close()">Fermer</button>
    <button mat-button mat-stroked-button (click)="save()">Sauvegarder</button>
</mat-dialog-actions>